import React from 'react';
import Row from 'react-bootstrap/Row';
import {CircleLoader} from 'react-spinners';
import classNames from 'classnames';
import css from './Loader.module.css';

export type LoaderProps = {
  loading: boolean;
  description?: string;
  progress?: number;
  variant?: 'black' | 'white';
};

export const Loader = ({
  loading,
  description,
  progress,
  variant,
}: LoaderProps) => {
  if (loading) {
    return (
      <>
        <Row className="justify-content-md-center">
          <CircleLoader color={variant} />
        </Row>
        <Row className="justify-content-md-center">
          {description}... {progress && <>{progress} % completed</>}
        </Row>
      </>
    );
  } else {
    return <></>;
  }
};

export type LoaderWrapperProps = {
  loading: boolean;
  description?: string | React.ReactElement;
  progress?: number;
  children: React.ReactElement | null;
  color?: string;
};

export const LoaderWrapper = ({
  loading,
  description = 'Loading',
  progress,
  children,
  color,
}: LoaderWrapperProps) => {
  if (loading) {
    return (
      <>
        <Row className="justify-content-md-center">
          <CircleLoader color={color} />
        </Row>
        <Row className="justify-content-md-center" style={{color}}>
          {description}... {progress && <>{progress} % completed</>}
        </Row>
      </>
    );
  } else {
    return children;
  }
};

export type LoaderWrapperLazyProps = {
  loading: boolean;
  description?: string;
  progress?: number;
  lazyChildren: () => React.ReactNode;
};

export const LoaderWrapperLazy = ({
  loading,
  description = 'Loading',
  progress,
  lazyChildren,
}: LoaderWrapperLazyProps) => {
  if (loading) {
    return (
      <>
        <Row className="justify-content-md-center">
          <CircleLoader />
        </Row>
        <Row className="justify-content-md-center">
          {description}... {progress && <>{progress} % completed</>}
        </Row>
      </>
    );
  } else {
    return lazyChildren();
  }
};

export const LoaderOverlay = ({
  backgroundColor = '#000000',
  color = '#ffffff',
  title = 'Loading',
  className,
}: {
  backgroundColor?: React.CSSProperties['backgroundColor'];
  color?: React.CSSProperties['color'];
  title?: string;
  className?: string;
}) => {
  return (
    <div
      className={classNames(css.fullPageLoader, className)}
      style={{backgroundColor}}
    >
      <CircleLoader color={color} />
      {title ? (
        <div style={{color, fontSize: 16, paddingTop: 6}}>{title}...</div>
      ) : null}
    </div>
  );
};
